<script setup lang="ts">
import { computed } from "vue";

import { useRoute } from "vue-router";

import GenericView from "./views/GenericView.vue";
import OPAView, { type OPASlug } from "./views/OPAView.vue";


const route = useRoute();
const override = computed(() => route.query.override as string | undefined);
const supportedSlugs = ["cjp", "tbmopa", "ejoa", "popa"] as const satisfies ReadonlyArray<OPASlug>;
const activeSlug = computed<OPASlug | null>(() => {
	const subdomain = window.location.hostname.split(".")[0];
	const sub = override.value || subdomain;
	if (supportedSlugs.includes(sub as OPASlug)) {
		return sub as OPASlug;
	}
	return null;
});
</script>
<template>
  <UApp>
    <OPAView
      v-if="activeSlug"
      :opa="activeSlug"
    />
    <GenericView v-else />
  </UApp>
</template>
